const translations = {
  "en": {
    "No change": "No change",
    "since last update": "since last update"
  },
  "zh-tw": {
    "No change": "無變動",
    "since last update": "自上次更新以來"
  }
};

export default translations;
